import React from "react";

interface DownChevronIconProps {
  className?: string;
}

export const DownChevronIcon = ({ className }: DownChevronIconProps) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.72217 1.45142L6.87356 0.5L4.11106 3.59042L1.34856 0.5L0.499946 1.45142L4.11106 5.5L7.72217 1.45142Z"
      fill="black"
    />
  </svg>
);

DownChevronIcon.defaultProps = {
  className: "",
};
